import { useEffect, useRef } from 'react';

type EventCallback = (event: Event) => void;

export const useEventListener = (
    eventName: string,
    handler: EventCallback,
    element = window,
) => {
    const savedHandlerRef = useRef<EventCallback>(null);

    useEffect(() => {
        savedHandlerRef.current = handler;
    }, [handler]);

    useEffect(() => {
        const isSupported = element && element.addEventListener;
        if (!isSupported) {
            return;
        }

        const eventListener = (event: any) => {
            if (event && savedHandlerRef && savedHandlerRef.current) {
                (savedHandlerRef as any).current(event);
            }
        };
        element.addEventListener(eventName, eventListener);

        return () => {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName, element]);
};
